import { blockCategories } from '../../categories';

export default (editor) => {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    blockManager.add('grid').set({
        label: 'Raster',
        category: blockCategories.layout,
        content: {
            type: 'grid',
            classes: ['tw-grid', 'grid', 'gap-4', 'p-2', 'my-4'],
        },

        media: `
        <svg aria-hidden="true"  focusable="false" data-prefix="fas" data-icon="equals" class="svg-inline--fa fa-equals fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
        `,
    });

    const defaultType = domComponents.getType('default');
    const defaultModel = defaultType.model;
    const defaultView = defaultType.view;

    domComponents.addType('grid', {
        model: {
            defaults: Object.assign({}, defaultModel.prototype.defaults, {
                'custom-name': 'grid',
                tagName: 'div',
                draggable: 'div',
                droppable: true,
                traits: [
                    {
                        type: 'class_select',
                        options: [
                            { value: 'grid-cols-none', name: 'None' },
                            { value: 'grid-cols-1', name: 'Cols 1' },
                            { value: 'grid-cols-2', name: 'Cols 2' },
                            { value: 'grid-cols-3', name: 'Cols 3' },
                            { value: 'grid-cols-4', name: 'Cols 4' },
                            { value: 'grid-cols-5', name: 'Cols 5' },
                            { value: 'grid-cols-6', name: 'Cols 6' },
                            { value: 'grid-cols-7', name: 'Cols 7' },
                            { value: 'grid-cols-8', name: 'Cols 8' },
                            { value: 'grid-cols-9', name: 'Cols 9' },
                            { value: 'grid-cols-10', name: 'Cols 10' },
                            { value: 'grid-cols-11', name: 'Cols 11' },
                            { value: 'grid-cols-12', name: 'Cols 12' },
                            {
                                value: 'grid-cols-subgrid',
                                name: 'Cols Subgrid',
                            },
                        ],
                        label: 'Columns',
                        default: 'grid-cols-3',
                        name: 'columns',
                    },
                    {
                        type: 'class_select',
                        options: [
                            { value: 'grid-rows-none', name: 'None' },
                            { value: 'grid-rows-1', name: 'Rows 1' },
                            { value: 'grid-rows-2', name: 'Rows 2' },
                            { value: 'grid-rows-3', name: 'Rows 3' },
                            { value: 'grid-rows-4', name: 'Rows 4' },
                            { value: 'grid-rows-5', name: 'Rows 5' },
                            { value: 'grid-rows-6', name: 'Rows 6' },
                            { value: 'grid-rows-7', name: 'Rows 7' },
                            { value: 'grid-rows-8', name: 'Rows 8' },
                            { value: 'grid-rows-9', name: 'Rows 9' },
                            { value: 'grid-rows-10', name: 'Rows 10' },
                            { value: 'grid-rows-11', name: 'Rows 11' },
                            { value: 'grid-rows-12', name: 'Rows 12' },
                            {
                                value: 'grid-rows-subgrid',
                                name: 'Rows Subgrid',
                            },
                        ],
                        label: 'Rows',
                        name: 'rows',
                        default: 'grid-rows-none',
                    },
                ].concat(defaultModel.prototype.defaults.traits),
            }),
        },
        isComponent(el) {
            if (el && el.classList && el.classList.contains('tw-grid')) {
                return { type: 'grid' };
            }
        },
        view: defaultView,
    });
};
